import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20hexagonal%20traditional%20Chinese%20string%20instrument%20liujiaoqin%20displayed%20elegantly%20on%20a%20dark%20wooden%20surface%20with%20soft%20dramatic%20side%20lighting%2C%20rich%20warm%20amber%20and%20golden%20tones%2C%20artistic%20still%20life%20composition%2C%20shallow%20depth%20of%20field%2C%20luxurious%20and%20cultural%20aesthetic%2C%20dark%20atmospheric%20background%20with%20subtle%20texture&width=1600&height=900&seq=hero-banner-2026-01&orientation=landscape"
          alt="六角琴 - 专业演奏与入门选购完全指南"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            六角琴专业指南
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed">
            从入门教程到专业演奏，从选购指南到品牌对比——琴韵阁为您提供最全面、最专业的六角琴学习与选购资源。
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/ru-men-jiao-cheng"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
              开始学习
            </Link>
            <Link
              to="/category/xuan-gou-zhi-nan"
              className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 px-6 py-3 rounded-md font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center"></i>
              选购指南
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}